import type { ReactNode } from "react";

interface ContainerProps {
	children: ReactNode;
	className?: string;
}

export default function Container({ children, className = "" }: ContainerProps) {
	return <div className={`max-w-[960px] mx-auto px-8 ${className}`}>{children}</div>;
}
